import { useBizTypeTranslation } from "hooks/useBizTypeTranslation";
import CustomPage from "../../../components/CustomPage";
import { useEffect, useState } from "react";
import { apiUrl } from "../../../config/settings";
import { useDispatch, useSelector } from "react-redux";
import http from "../../../http";
import { setDeleteMassage, setShowLoading } from "../../../store/sysSlice";
import Details from "./Details";
import { ArrowForwardIos, CopyAll, Delete, DeleteOutline, Edit } from "@mui/icons-material";
import CustomButton from "../../../components/CustomButton";
import { Checkbox, CircularProgress, IconButton, Stack, Typography } from "@mui/material";
import { endpointNameItems } from "../const";
import useDataManager from "../../../hooks/useDataManager";
import CustomDataGrid from "components/customDataGrid";
import { useNavigate, useParams } from "react-router-dom";
import CustomIconButton from "components/CustomIconButton";
import moment from "moment";
import { DATE_TIME_FORMAT } from "config/const";
import CustomDialog from "components/CustomDialog";
import { lineText } from "config/functions";
import { DEPARTMENT_MANAGER, ROLES_ID } from "config/roles";
import CustomTabs from "components/CustomTabs";
import CheckRole from "components/CheckRole";

const CheckItem = () => {
  const navigate = useNavigate();
  const { clientId } = useParams();
  const { checkListId } = useParams();
  const { removeItem, editItem, addItem } = useDataManager();
  const dispatch = useDispatch();
  const { bt } = useBizTypeTranslation();
  const maxItems = useSelector((state) => state?.biz?.data?.plan?.maxItems);
  const clients = useSelector((state) => state?.clients?.list);
  const employees = useSelector((state) => state?.employees?.list);
  const userRole = useSelector((state) => state.userSettings?.user?.userRole);
  const [list, setList] = useState([]);
  const [listFilter, setListFilter] = useState([]);
  const [client, setClient] = useState(null);
  const [itemDetails, setItemDetails] = useState(null);
  const [itemDesc, setItemDesc] = useState(null);
  const [isClosedLoading, setIsClosedLoading] = useState(null);
  const [approvalLoading, setApprovalLoading] = useState(null);
  const [selectedTab, setSelectedTab] = useState(0);

  const columns = [
    {
      field: "isClosed",
      headerName: bt("STATUS"),
      width: 70,
      filterable: false,
      renderCell: (values) => {
        return (
          <Stack height='100%' alignItems='center' justifyContent='center'>
            {isClosedLoading === values?.row?.id
              ? <CircularProgress size="20px" />
              : <Checkbox
                checked={values?.row?.isClosed}
                onClick={(e) => {
                  e.stopPropagation();
                  changeStatus(values?.row?.id)
                }}
              />}
          </Stack>
        );
      }
    },
    {
      field: "approval",
      headerName: bt("APPROVAL"),
      width: 70,
      hide: selectedTab === 0,
      filterable: false,
      renderCell: (values) => {
        return (
          <Stack height='100%' alignItems='center' justifyContent='center'>
            {approvalLoading === values?.row?.id
              ? <CircularProgress size="20px" />
              : <Checkbox
                checked={values?.row?.approval}
                onClick={(e) => {
                  e.stopPropagation();
                  onChangeApproval(values?.row?.id)
                }}
              />}
          </Stack>
        );
      }
    },
    {
      field: "name",
      headerName: bt("NAME"),
      width: 200,
    },
    {
      field: "desc",
      headerName: bt("DESC"),
      width: 250,
      renderCell: (values) => {
        return (
          values?.row?.desc
            ? <Stack height='100%' justifyContent='center'>
              <CustomButton
                variant="outlined"
                title={values?.row?.desc}
                onClick={(e) => {
                  e.stopPropagation();
                  setItemDesc(values?.row?.desc)
                }}
              />
            </Stack>
            : null
        )
      }
    },
    {
      field: "created",
      headerName: bt("CREATED"),
      width: 150,
    },
    {
      field: "closedDate",
      headerName: bt("CLOSED_DATE"),
      width: 150,
    },
    {
      field: "employeesNames",
      hide: userRole === ROLES_ID.EMPLOYEE,
      headerName: bt("EMPLOYEES"),
      width: 150,
    },
    {
      field: "edit",
      headerName: bt("EDIT"),
      width: 100,
      hideInExport: true,
      filterable: false,
      renderCell: (values) => {
        return (
          <IconButton
            onClick={(e) => {
              e.stopPropagation();
              setItemDetails(values?.row);
            }}
          >
            <Edit />
          </IconButton>
        );
      },
    },
    {
      field: "copy",
      headerName: bt("COPY"),
      width: 100,
      hideInExport: true,
      filterable: false,
      renderCell: (values) => {
        return (
          <IconButton
            onClick={(e) => {
              e.stopPropagation();
              copyItem(values?.row);
            }}
          >
            <CopyAll />
          </IconButton>
        );
      },
    },
    {
      field: "delete",
      headerName: bt("DELETE"),
      width: 100,
      filterable: false,
      renderCell: (row) => {
        return (
          <IconButton
            onClick={(e) => {
              e.stopPropagation();
              deleteItemDetail(row.id);
            }}
          >
            <DeleteOutline sx={{ color: "error.text" }} />
          </IconButton>
        );
      },
    },
  ]

  const TABS = [
    { id: 0, title: 'OPEN' },
    { id: 1, title: 'CLOSED' },
    { id: 2, title: 'HISTORY' },
  ]

  useEffect(() => {
    if (checkListId && clients?.length > 1 && list?.length === 0) {
      getData();
    }
  }, [checkListId, clients]);

  useEffect(() => {
    let newList = [...list]
    if (selectedTab === 0)
      newList = newList?.filter(i => !i?.isClosed)
    else if (selectedTab === 1)
      newList = newList?.filter(i => i?.isClosed && !i?.approval)
    else if (selectedTab === 2)
      newList = newList?.filter(i => i?.isClosed && i?.approval)

    setListFilter(newList)
  }, [selectedTab, list]);

  const getData = () => {
    dispatch(setShowLoading(true));
    http.get(`${apiUrl}/${endpointNameItems}/${checkListId}`).then((res) => {
      setList(res?.data?.data);
      setClient(clients?.find((c) => c?._id === clientId));
      dispatch(setShowLoading(false));
    });
  };

  const itemDetailsHandle = (item) => {
    setItemDetails(item);
  };

  const deleteItemDetail = (id) => {
    dispatch(
      setDeleteMassage({
        massage: "DELETE_CHECK_LIST_ITEM",
        onClick: () => {
          dispatch(setShowLoading(true));
          http
            .delete(`${apiUrl}/${endpointNameItems}/${id}`)
            .then((res) => {
              dispatch(setShowLoading(false));
              const newList = removeItem(id, list);
              setList(newList);
            })
            .catch((error) => {
              dispatch(setShowLoading(false));
            });
        },
      })
    );
  };

  const backToClients = () => {
    navigate(`/Check-List/${clientId}`);
  }

  const changeStatus = (id) => {
    setIsClosedLoading(id)
    const item = list?.find((i) => i?.id === id);

    http.patch(`${apiUrl}/${endpointNameItems}/${id}`, { isClosed: !item?.isClosed })
      .then((res) => {
        const newList = editItem({
          ...item,
          isClosed: !item?.isClosed,
          closedDate: !item?.isClosed ? moment() : null,
          approval: false,
        }, list);
        setList(newList);
        setIsClosedLoading(null)
      })
      .catch(error => setIsClosedLoading(null))
  }

  const onChangeApproval = (id) => {
    setApprovalLoading(id)
    const item = list?.find((i) => i?.id === id);
    http.patch(`${apiUrl}/${endpointNameItems}/${id}`, { approval: !item?.approval })
      .then((res) => {
        const newList = editItem({ ...item, approval: !item?.approval }, list);
        setList(newList);
        setApprovalLoading(null)
      })
      .catch(error => setApprovalLoading(null))
  }

  const copyItem = (item) => {
    dispatch(setShowLoading(true));
    http.post(`${apiUrl}/${endpointNameItems}/copy/${item?.id}`)
      .then((res) => {
        dispatch(setShowLoading(false));
        if (res?.data?.id === 1) {
          const data = {
            ...item,
            id: res?.data?.itemId,
            name: `${item?.name} Copy`,
            isClosed: false,
            closedDate: null,
            created: moment()
          };

          const newList = addItem(data, list);
          setList(newList);
          setItemDetails(data);
        }
      })
      .catch((error) => {
        dispatch(setShowLoading(false));
        console.error("error", error)
      });
  }

  return (
    <CustomPage
      title={`${bt("TASKS")} -  ${client ? client?.company || client?.contactName : ""}`}
      icon={
        <CustomIconButton
          size={30}
          iconColor='primary'
          hideBgcolor icon={<ArrowForwardIos fontSize="small" />}
          onClick={backToClients}
        />
      }
      header={
        <Stack direction="row" justifyContent="end">
          <CustomButton title="NEW"
            disabled={maxItems > 0 && list?.length >= maxItems}
            onClick={() => itemDetailsHandle({ id: "new" })}
          />
        </Stack>
      }
    >
      <Stack height='100%'>
        <CheckRole role={DEPARTMENT_MANAGER}>
          <CustomTabs tabList={TABS} callBackFunc={(tab) => setSelectedTab(tab)} />
        </CheckRole>

        <CustomDataGrid
          setItem={(i) => setItemDetails(i)}
          columns={columns}
          list={listFilter?.map((item) => {
            return {
              ...item,
              id: item?.id,
              employeesNames: item?.employees?.length > 0
                ? item?.employees?.map((emp) => {
                  const employee = employees?.find((e) => e?.id === emp);
                  return employee ? `${employee?.fn} ${employee?.ln}` : "";
                }
                ).join(", ")
                : "",
              closedDate: item?.isClosed ? moment(item?.closedDate).format(DATE_TIME_FORMAT) : "",
              created: moment(item?.created).format(DATE_TIME_FORMAT),
            }
          })}
        />

      </Stack>

      {itemDetails
        ?
        <Details
          item={itemDetails}
          userRole={userRole}
          employees={employees}
          setList={setList}
          list={list}
          setItem={setItemDetails}
          getData={getData}
          checkListId={checkListId}
        />
        : null
      }

      {itemDesc
        ? <CustomDialog
          open={itemDesc ? true : false}
          title={bt("DESC")}
          onClose={() => setItemDesc(null)}
          closeBtn="CLOSE"
        >
          <Stack minWidth={{ xs: "auto", sm: 250 }}>
            <Typography textAlign='center' padding={1}>
              {lineText(itemDesc)}
            </Typography>
          </Stack>
        </CustomDialog>
        : null
      }
    </CustomPage>
  );
};
export default CheckItem;
